import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "../../../../../Components/CSS/FormStyle.css";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../Components/FormLoader/FormLoader";

class AddExam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        name: "",
      },
      loading: false,
      examTypeError: "",
    };
  }

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  checkError = (examType) => {
    let examTypeError = examType ? examType : "";
    if (examTypeError) {
      this.setState({ examTypeError });
      return true;
    } else {
      this.setState({ examTypeError: "" });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        const response = await Axios.post(
          `${url}/api/exam-types`,
          this.state.data,
          {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          }
        );
        if (response.data.message === "Exam Type added successfully") {
          this.setState({ data: { name: "" }, loading: false });
          this.props.getExams();
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data.message ===
          "Exam type with given name already in database"
        ) {
          console.clear();
          this.checkError("Exam Type already registered");
        }
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Paper className={classes.paper}>
          <form onSubmit={this.handleSubmit}>
            <div>
              <TextField
                name="name"
                type="text"
                label="Exam Name"
                required
                fullWidth
                variant="outlined"
                margin="normal"
                placeholder="E.g First Term or Second Term Or Unit Test"
                error={this.state.examTypeError ? true : false}
                helperText={this.state.examTypeError}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.name}
                onChange={this.handleChange}
              />
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="submit"
                aria-label="Submit"
                variant="outlined"
                className={classes.buttonStyle}
              >
                Submit
              </Button>
              {this.state.loading && <FormLoader />}
            </div>
          </form>
        </Paper>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddExam)));
